import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConToken } from '../../helpers/fetch';
import { useLocation } from 'react-router';
import moment from 'moment';
import { startAlerta } from '../../actions/ui/alertas';
import { fetchFiltrosGuardados } from '../../actions/indicadores';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const GuardarFiltrosModal=({abrirModal, setAbrirModal})=> {
  const dispatch=useDispatch()
  const query=useQuery()
  const auth = useSelector(state => state.auth)

  const [name, setname] = useState("")
  const [disabled, setDisabled] = useState(false)

  const handleClose = () => {
    setAbrirModal(false);
  };

  const handleGuardarFiltro= async ()=>{
    setDisabled(true)
    try {
      let filtros={
        fecNacDesde: query.get('fecNacDesde') ? query.get('fecNacDesde') : null,
        fecNacHasta: query.get('fecNacHasta') ? query.get('fecNacHasta') : null,
        fecAltaDesde: query.get('fecAltaDesde') ? query.get('fecAltaDesde') : null,
        fecAltaHasta: query.get('fecAltaHasta') ? query.get('fecAltaHasta') : null,
        fecBajaDesde: query.get('fecBajaDesde') ? query.get('fecBajaDesde') : null,
        fecBajaHasta: query.get('fecBajaHasta') ? query.get('fecBajaHasta') : null,
        provincias: query.get('provincias') ? query.get('provincias').split(",") : null,
        localidades: query.get('localidades') ? query.get('localidades').split(",") : null,
        seccionales: query.get('seccionales') ? query.get('seccionales').split(",") : null,
      }
      const data={
        idUser:auth.idUsuario,
        nombre:name,
        seteo:JSON.stringify(filtros),
        fecha:moment().format()
      }
      await fetchConToken(`Filtros`, data, "POST")
      dispatch(startAlerta("Filtro guardado exitosamente", "success"));
      dispatch(fetchFiltrosGuardados());

      setDisabled(false)
      handleClose()
    } catch (error) {
      setDisabled(false)
      dispatch(startAlerta("Error al guardar el filtro", "error", "Error"));
    }
  }

  return (
      <Dialog open={abrirModal} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Guardar Filtro</DialogTitle>
        <DialogContent>
          <DialogContentText>
            A continuación, ingrese un nombre para guardar estos filtros aplicados y pueda volver a utilizarlo en un futuro.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Nombre"
            fullWidth
            required
            value={name}
            onChange={e=>setname(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleGuardarFiltro} color="primary" variant="contained" disabled={disabled}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
  );
}